import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './WorkWithUsPage.css';

const FORMSPREE_ENDPOINT = `https://formspree.io/f/${process.env.REACT_APP_FORMSPREE_ID}`;

export default function WorkWithUsPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(form),
      });
      setStatus(res.ok ? 'success' : 'error');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="wwu-page">
        <Link to="/" className="go-back">← Back</Link>
        <h1 className="wwu-title">Message sent.</h1>
        <p className="wwu-subtitle">Thanks — we'll be in touch soon.</p>
      </div>
    );
  }

  return (
    <div className="wwu-page">
      <Link to="/" className="go-back">← Back</Link>
      <h1 className="wwu-title">Ready to tinker?</h1>
      <p className="wwu-subtitle">
        Tell us about your project — VR/XR, installations, embedded systems, or something in between.
        We'll get back to you.
      </p>

      <form className="wwu-form" onSubmit={handleSubmit}>
        <div className="wwu-field">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            placeholder="Your name or studio"
          />
        </div>
        <div className="wwu-field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            placeholder="you@example.com"
          />
        </div>
        <div className="wwu-field">
          <label htmlFor="subject">Subject</label>
          <input
            id="subject"
            type="text"
            name="subject"
            value={form.subject}
            onChange={handleChange}
            required
            placeholder="What's this about?"
          />
        </div>
        <div className="wwu-field">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            value={form.message}
            onChange={handleChange}
            required
            placeholder="Tell us about your project, timeline, and goals…"
            rows={7}
          />
        </div>

        {status === 'error' && (
          <p className="wwu-error">Something went wrong — email us directly <a href="mailto:luke@lukedturner.com">here</a>.</p>
        )}

        <button type="submit" className="wwu-submit" disabled={status === 'submitting'}>
          {status === 'submitting' ? 'Sending…' : 'Send Message →'}
        </button>
      </form>
    </div>
  );
}
